import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";

function EntregarNota() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ARTICULOS_VENTAS_TIENDAS =
    import.meta.env.VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const AREAS_GENERAL = import.meta.env.VITE_AREAS_GENERAL;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;

  const [notas, setNotas] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [selectedNota, setSelectedNota] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [total_cantidad_nueva, setTotalCantidadNueva] = useState(0);
  const [totalDinero, setTotalDinero] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [botonGuardar, setBotonGuardar] = useState(false);

  // Add state for expanded tables
  const [expandedTables, setExpandedTables] = useState({});

  useMemo(() => {
    if (user.areas) {
      if (user.areas != AREAS_GENERAL) {
        axios
          .get(`${URL_VENTAS_TIENDAS}Apartados/${user.areas}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const notas = res.data;
            setNotas(notas);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        axios
          .get(`${URL_VENTAS_TIENDAS}ApartadosGeneral`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const notas = res.data;
            setNotas(notas);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }

    if (selectedNota) {
      axios
        .get(`${URL_ARTICULOS_VENTAS_TIENDAS}Nota/${selectedNota}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allArticulos = response.data;
          if (user.areas == allArticulos[0].ventasTiendas[0].areas[0]._id) {
            if (allArticulos[0].ventasTiendas[0].entregado == "No") {
              let arrayArticulos = allArticulos.map((a) => {
                return {
                  codigo: a.articulos[0].codigo,
                  nombre: a.articulos[0].nombre,
                  colorNombre: a.colores[0].name,
                  idColor: a.colores[0]._id,
                  tallaNombre: a.tallas[0].name,
                  piezasPorCaja: a.articulos[0].piezasPorCaja,
                  cantidad: a.cantidad,
                  cajas: (
                    parseFloat(a.cantidad) /
                    parseFloat(a.articulos[0].piezasPorCaja)
                  ).toFixed(2),
                  _id: a._id,
                  inventarios: a.inventarios[0]._id,
                  colores: a.colores,
                  articulos: a.articulos[0]._id,
                  id: a._id,
                  precioOriginal: a.articulos[0].precioOriginal || 0,
                  precio: a.articulos[0].precio || 0,
                  cantInv: a.cantInv || 0,
                };
              });
              setArticulos(arrayArticulos);

              let cant = allArticulos.map((c) => parseFloat(c.cantidad));
              let TC = cant.reduce((t, total, index) => t + total, 0);
              setTotalCantidadNueva(TC);
              setBotonGuardar(true);
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "La Nota ya fue entregada",
              });
              setSelectedNota("");
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "La nota No pertenece a tu tienda",
            });
            setSelectedNota("");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user, selectedNota]);

  useEffect(() => {
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function guardaEntregado() {
    toggleProgreso();
    axios
      .patch(
        `${URL_VENTAS_TIENDAS}EntregarApartado/${selectedNota}`,
        {
          entregado: "Si",
          clientes: selectedCliente,
          total_general: totalDinero,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        let totalPedido = articulos.length;

        articulos.map((a) => {
          axios
            .patch(
              `${URL_ARTICULOS_VENTAS_TIENDAS}Entregar/${a._id}`,
              {
                cantidad: a.cantidad,
                inventarios: a.inventarios,
                entregado: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalPedido = totalPedido - 1;
              if (totalPedido == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Entregar Venta de Tienda",
                      detalle: `${a._id}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", `success`);
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                    });
                    console.log(error);
                  });
              }
            });
        });

        Swal.fire({
          position: "center",
          icon: "success",
          title: "Se Entrego",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Piezas por Caja", field: "piezasPorCaja", sortable: true },
    { name: "Cajas", field: "cajas", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
  ];

  function jalaNota(id) {
    setSelectedNota(id);
    notas.map((a) => {
      if (a._id == id) {
        setSelectedCliente(a.clientes[0]._id);
        setTotalDinero(a.total_general);
      }
    });
  }

  // Group the articles by nombre - following the exact same logic as the first example
  const groupedArticulos = articulos.reduce((acc, field) => {
    const key = `${field.nombre}`;
    if (!acc[key]) {
      acc[key] = {
        articuloInfo: {
          articulosNombre: field.nombre,
          articulos: field.articulos,
          availableTallas: Array.from(
            new Set(
              articulos
                .filter((f) => f.nombre === field.nombre)
                .map((f) => f.tallaNombre)
                .filter(Boolean)
                .sort((a, b) => {
                  return customSizeOrder.indexOf(a) - customSizeOrder.indexOf(b);
                })
            )
          ),
        },
        colorGroups: [],
      };
    }

    const existingColorIndex = acc[key].colorGroups.findIndex(
      (item) => item.idColor === field.idColor
    );

    if (existingColorIndex === -1) {
      acc[key].colorGroups.push({
        id: field.id,
        articulos: field.articulos,
        articulosNombre: field.nombre,
        idColor: field.idColor,
        colorNombre: field.colorNombre,
        colores: field.colores,
        quantities: {
          [field.tallaNombre]: {
            cantidad: field.cantidad,
            id: field.id,
            cantInv: field.cantInv,
          },
        },
      });
    } else {
      acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre] = {
        cantidad: field.cantidad,
        id: field.id,
        cantInv: field.cantInv,
      };
    }
    return acc;
  }, {});

  let totalCajas = 0;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.entregarNota ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuTiendas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>

          <h3 align="center">Entrega de Mercancia</h3>
          <Col md={3}>
            <Label className="mr-sm-2">Apartados</Label>
            <Input
              className="col-sm-12"
              type="select"
              value={selectedNota}
              required
              onChange={(e) => {
                jalaNota(e.target.value);
              }}
            >
              <option value="0">Selecciona </option>
              {notas
                .sort((a, b) => (a.idVentaTienda < b.idVentaTienda ? 1 : -1))
                .map((a) => {
                  return (
                    <option value={a._id}>
                      {a.prefijo} {a.consecutivo}{" "}
                      {a.clientes[0].nombre_comercial}
                    </option>
                  );
                })}
            </Input>
          </Col>
          <br />

          <div>
            {Object.entries(groupedArticulos).map(
              ([articuloNombre, { articuloInfo, colorGroups }]) => {
                // Calculate totals for this article
                const articleTotals = colorGroups.reduce(
                  (totals, group) => {
                    const quantitySum = Object.values(group.quantities).reduce(
                      (sum, q) => sum + (parseFloat(q.cantidad) || 0),
                      0
                    );

                    return {
                      items: totals.items + quantitySum,
                    };
                  },
                  { items: 0 }
                );

                return (
                  <div key={articuloNombre} className="mb-8">
                    <div className="d-flex align-items-center border-t-2 border-gray-200 pt-2 pb-2 bg-gray-50">
                      <div className="d-flex align-items-center">
                        <Button
                          size="sm"
                          className="btn mr-3"
                          color="info"
                          onClick={() =>
                            setExpandedTables((prev) => ({
                              ...prev,
                              [articuloNombre]: !prev[articuloNombre],
                            }))
                          }
                        >
                          <i
                            className={`fas fa-chevron-${
                              !expandedTables[articuloNombre] ? "up" : "down"
                            }`}
                          ></i>
                        </Button>
                        <h4 className="negrita mb-0 mr-4">{articuloNombre}</h4>
                      </div>
                      <div className="d-flex align-items-center">
                        <span
                          className="mr-4 text-dark"
                          style={{ fontSize: "18px" }}
                        >
                          <strong style={{ fontSize: "18px" }}>Piezas:</strong>{" "}
                          {articleTotals.items}
                        </span>
                      </div>
                    </div>

                    {!expandedTables[articuloNombre] && (
                      <Table borderless>
                        <thead>
                          <tr>
                            <th>Articulo</th>
                            <th>Color</th>
                            {articuloInfo.availableTallas.map((talla) => (
                              <th key={talla} style={{ maxWidth: "35px" }}>
                                {talla}
                              </th>
                            ))}
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {colorGroups.map((group) => (
                            <tr key={`${group.id}-${group.idColor}`}>
                              <td style={{ maxWidth: "60px" }}>
                                <Input
                                  name="articulo"
                                  type="string"
                                  placeholder="Articulo"
                                  value={group.articulosNombre}
                                  disabled
                                />
                              </td>
                              <td style={{ maxWidth: "35px" }}>
                                <Input
                                  name="idColor"
                                  type="select"
                                  value={group.idColor}
                                  disabled
                                >
                                  <option value="">Selecciona</option>
                                  {group.colores?.map((a) => (
                                    <option key={a._id} value={a._id}>
                                      {a.name}
                                    </option>
                                  ))}
                                </Input>
                              </td>
                              {articuloInfo.availableTallas.map((talla) => (
                                <td key={talla} style={{ maxWidth: "40px" }}>
                                  <Input
                                    name="cantidad"
                                    type="number"
                                    min="0"
                                    step="any"
                                    value={
                                      group.quantities[talla]?.cantidad || 0
                                    }
                                    disabled
                                  />
                                </td>
                              ))}

                              <td>
                                <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  disabled
                                  tabIndex="-1"
                                >
                                  <i className="fas fa-minus"></i>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </div>
                );
              }
            )}
          </div>

          {/* Original totals table for backward compatibility */}
          <Table
            size="sm"
            striped
            borderless
            className="table-responsive-xl d-none"
          >
            <tr>
              <th>Codigo</th>
              <th>Nombre</th>
              <th>Pzas Caja</th>
              <th>Cajas</th>
              <th>Cantidad</th>
            </tr>

            <tbody>
              {articulos.map((ao) => {
                totalCajas = totalCajas + parseFloat(ao.cajas);
                return (
                  <tr key={ao._id}>
                    <td>{ao.codigo}</td>
                    <td>{ao.nombre}</td>
                    <td>{ao.piezasPorCaja}</td>
                    <td>{ao.cajas}</td>
                    <td>{ao.cantidad}</td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  Total
                </td>
                <td className="negrita">{totalCajas.toFixed(2)}</td>
                <td className="negrita">{total_cantidad_nueva}</td>
              </tr>
            </tbody>
            <br />
            {validaBoton && botonGuardar ? (
              <Button
                type="submit"
                className="btn btn-success"
                tabIndex="-1"
                onClick={(e) => {
                  guardaEntregado();
                }}
              >
                Entregar
              </Button>
            ) : (
              <Button
                type="submit"
                className="btn btn-success"
                tabIndex="-1"
                disabled
              >
                Entregar
              </Button>
            )}
          </Table>

          {/* Button section */}
          <div className="m-3">
            {validaBoton && botonGuardar ? (
              <Button
                type="submit"
                className="btn btn-success"
                tabIndex="-1"
                onClick={(e) => {
                  guardaEntregado();
                }}
              >
                Entregar
              </Button>
            ) : (
              <Button
                type="submit"
                className="btn btn-success"
                tabIndex="-1"
                disabled
              >
                Entregar
              </Button>
            )}
          </div>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default EntregarNota;
